// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"2ad048fe","500":"78619a56","705":"db559726","827":"43957bc0"}[chunkId] + ".css";
};